import '../../styles/main.css';
 
export const DashboardShimmer = () => {
    return (
        <div className="w-100 h-100 d-flex flex-column justify-content-start align-items-start" style={{ overflowX: 'hidden', overflowY: 'auto' }}>
            {/* PoI Insights Section */}
            <div style={{ padding: '2.8125vh' }} className='w-100 d-flex flex-column justify-content-start align-items-start border-bottom'>
                {/* Title */}
                <div className='w-100 position-relative' style={{ height: '2.5vh', marginBottom: '1.5vh' }}>
                    <div className="shimmer position-absolute" style={{ width: '40%', borderRadius: '4px' }}></div>
                </div>
 
                {/* Subtitle */}
                <div className='w-100 position-relative' style={{ height: '1.8vh', marginBottom: '2vh' }}>
                    <div className="shimmer position-absolute" style={{ width: '50%', borderRadius: '4px' }}></div>
                </div>
 
                {/* Highlights Cards Shimmer */}
                <div className="w-100 d-flex gap-3 margin-bottom-4">
                    {[1, 2, 3].map((_, index) => (
                        <div key={index} className='position-relative border rounded p-3' style={{ width: '30%', height: '9.71vh' }}>
                            <div className="shimmer position-absolute" style={{ top: 0, left: 0, width: '100%', height: '100%', borderRadius: '8px' }}></div>
                        </div>
                    ))}
                </div>
 
                {/* Breakdown Table Header Shimmer */}
                <div className='w-100 position-relative' style={{ height: '3.774vh', marginBottom: '2vh' }}>
                    <div className="shimmer position-absolute" style={{ width: '60%', borderRadius: '4px' }}></div>
                </div>
 
                {/* Table Shimmer */}
                <div className='w-100 position-relative' style={{ height: '56.45vh', marginBottom: '2vh' }}>
                    <div className="shimmer position-absolute" style={{ width: '100%', borderRadius: '8px' }}></div>
                </div>
 
                {/* TreeMap Shimmer */}
                <div className='w-100 position-relative' style={{ height: '28rem' }}>
                    <div className="shimmer position-absolute" style={{ width: '100%', borderRadius: '8px' }}></div>
                </div>
            </div>
 
            {/* PoI Insights Across All Categories Section */}
            <div style={{ padding: '2.8125vh' }} className='w-100 d-flex flex-column justify-content-start align-items-start border-bottom'>
                {/* Title */}
                <div className='w-100 position-relative' style={{ height: '2.5vh', marginBottom: '1.5vh' }}>
                    <div className="shimmer position-absolute" style={{ width: '45%', borderRadius: '4px' }}></div>
                </div>
 
                {/* Subtitle */}
                <div className='w-100 position-relative' style={{ height: '1.8vh', marginBottom: '2vh' }}>
                    <div className="shimmer position-absolute" style={{ width: '35%', borderRadius: '4px' }}></div>
                </div>
 
                {/* Highlights Cards Shimmer */}
                <div className="w-100 d-flex gap-3 margin-bottom-4">
                    {[1, 2, 3].map((_, index) => (
                        <div key={index} className='position-relative border rounded p-3' style={{ width: '30%', height: '9.71vh' }}>
                            <div className="shimmer position-absolute" style={{ top: 0, left: 0, width: '100%', height: '100%', borderRadius: '8px' }}></div>
                        </div>
                    ))}
                </div>
 
                {/* Section Title */}
                <div className='w-100 position-relative' style={{ height: '2vh', marginBottom: '2vh' }}>
                    <div className="shimmer position-absolute" style={{ width: '40%', borderRadius: '4px' }}></div>
                </div>
 
                {/* Bar Chart Shimmer */}
                <div className='w-100 position-relative' style={{ height: '23.625rem' }}>
                    <div className="shimmer position-absolute" style={{ width: '100%', borderRadius: '8px' }}></div>
                </div>
            </div>
 
            {/* Deep Dive Section */}
            <div style={{ padding: '2.8125vh' }} className='w-100 d-flex flex-column justify-content-start align-items-start'>
                {/* Title */}
                <div className='w-100 position-relative' style={{ height: '2.5vh', marginBottom: '1.5vh' }}>
                    <div className="shimmer position-absolute" style={{ width: '35%', borderRadius: '4px' }}></div>
                </div>
 
                {/* Subtitle */}
                <div className='w-100 position-relative' style={{ height: '1.8vh', marginBottom: '2vh' }}>
                    <div className="shimmer position-absolute" style={{ width: '55%', borderRadius: '4px' }}></div>
                </div>
 
                {/* Category Tabs Shimmer */}
                <div className='w-100 d-flex gap-4 margin-bottom-4' style={{ height: '6vh', borderBottom: 'thin solid #DBDBDB' }}>
                    {[1, 2, 3, 4].map((_, index) => (
                        <div key={index} className='position-relative' style={{ width: '15%', height: '2vh' }}>
                            <div className="shimmer position-absolute" style={{ width: '100%', borderRadius: '4px' }}></div>
                        </div>
                    ))}
                </div>
 
                {/* Highlights Cards Shimmer */}
                <div className="w-100 d-flex gap-3 margin-bottom-4">
                    {[1, 2, 3].map((_, index) => (
                        <div key={index} className='position-relative border rounded p-3' style={{ width: '30%', height: '9.71vh' }}>
                            <div className="shimmer position-absolute" style={{ top: 0, left: 0, width: '100%', height: '100%', borderRadius: '8px' }}></div>
                        </div>
                    ))}
                </div>
 
                {/* Line Chart Shimmer */}
                <div className='w-100 position-relative' style={{ height: '28rem', marginBottom: '2vh' }}>
                    <div className="shimmer position-absolute" style={{ width: '100%', borderRadius: '8px' }}></div>
                </div>
 
                {/* TreeMap Shimmer */}
                <div className='w-100 position-relative' style={{ height: '28rem', marginBottom: '2vh' }}>
                    <div className="shimmer position-absolute" style={{ width: '100%', borderRadius: '8px' }}></div>
                </div>
 
                {/* Sub-category Line Chart Shimmer */}
                <div className='w-100 position-relative' style={{ height: '28rem' }}>
                    <div className="shimmer position-absolute" style={{ width: '100%', borderRadius: '8px' }}></div>
                </div>
            </div>
        </div>
    );
};
 